import React from "react";
import "./mission-vision.css";

const MissionVision = () => {
  return (
    <section className="mv-section">
      {/* Mission Panel */}
      <div className="mv-left">
        <div className="mv-content">
          <h2>Our Mission</h2>
          <p>
           At Fundswalle, our mission is to redefine personal lending by making credit simple, swift, and accessible for every salaried individual. We aim to empower people with financial confidence through solutions that are transparent, affordable, and tailored to their unique goals.
In collaboration with Marathon Finlease Private Limited, a respected NBFC registered with the Reserve Bank of India (RBI), we are committed to delivering secure and seamless loan experiences built on trust, integrity, and innovation — ensuring that financial support is always within reach when it matters most.

          </p>
        </div>
       
      </div>

      {/* Vision Panel */}
      <div className="mv-right">
        <div className="mv-content">
          <h2>Our Vision</h2>
          <p>
            At Fundswalle, our vision is to transform the way salaried professionals in India experience personal finance. We aspire to build a transparent, customer-first platform that ensures access to credit precisely when it’s needed most.
By harnessing cutting-edge technology and deep financial expertise, we aim to create a future where financial inclusion is not a privilege but a reality for everyone — empowering individuals from all walks of life to achieve their goals with confidence and stability.

          </p>
        </div>
     
      </div>

      {/* Background shapes */}
      <div className="mv-shape mv-shape1"></div>
      <div className="mv-shape mv-shape2"></div>
      <div className="mv-shape mv-shape3"></div>
    </section>
  );
};

export default MissionVision;
